import React from 'react'
import { connect } from 'react-redux'
import { Field, change } from 'redux-form'
import { isTouchDevice } from '../utils/displayUtils'
import { shortTimeRangeString } from '../utils/dates'

import { renderSelectField, renderDropdownField, renderError } from '../form'

import { validRequired } from '../form/validate'

const BookingTimeSlot = ({ time_slots, dispatch, formName }) => {
  if (!(time_slots && time_slots.length > 0)) return null

  return (
    <div className="field" style={{ marginBottom: 16 }}>
      <Field
        name="booking[time_slot]"
        placeholder="Choose a time slot"
        component={isTouchDevice() ? renderSelectField : renderDropdownField}
        onChange={(e, value) => {
          /* eslint-disable eqeqeq */
          const { start, end } = time_slots.find((t) => t.id == value)
          /* eslint-enable eqeqeq */
          dispatch(change(formName, 'booking[start_time]', start))
          dispatch(change(formName, 'booking[end_time]', end))
        }}
        items={time_slots.map(({ start, end, ...timeSlot }) => ({
          ...timeSlot,
          label: shortTimeRangeString(start, end),
        }))}
        validate={[validRequired]}
        white
      >
        <option value={null} disabled>
          Choose a time slot
        </option>
        {time_slots.map(({ id, start, end }) => (
          <option key={id} value={id}>
            {shortTimeRangeString(start, end)}
          </option>
        ))}
      </Field>

      <Field
        name="booking[time_slot]"
        component={renderError}
        validate={[validRequired]}
      />

      <Field name="booking[start_time]" component="input" type="hidden" />

      <Field name="booking[end_time]" component="input" type="hidden" />
    </div>
  )
}

export default connect()(BookingTimeSlot)
